<template>
  <div class="p-popup" :class="props.classCustom">
    <v-card>
      <div class="p-popup">
        <div class="p-popup_container">
          <div class="p-popup_close" @click="handleClose">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 30 30"
              fill="none"
            >
              <path
                d="M23.75 8.0125L21.9875 6.25L15 13.2375L8.0125 6.25L6.25 8.0125L13.2375 15L6.25 21.9875L8.0125 23.75L15 16.7625L21.9875 23.75L23.75 21.9875L16.7625 15L23.75 8.0125Z"
                :fill="
                  props.classCustom == ('lp-ebisu-room' && 'use-scene')
                    ? '#7D987D'
                    : props.classCustom == 'lp-forparty'
                    ? '#A29447'
                    : '#2B7ECA'
                "
              />
            </svg>
          </div>
          <div class="p-popup_body">
            <h2 class="p-popup_body_title" v-if="showTitle">
            ケータリング問い合わせフォーム
            </h2>
            <h2 class="p-popup_body_title" v-if="showTitleTourFlag">
                {{ props.webTourStatus == 1 ? '会場見学問い合わせフォーム' : '会場問い合わせフォーム' }}
            </h2>
            <h2 class="p-popup_body_title" v-if="!showTitleTourFlag && !showTitle">
              会場問い合わせフォーム
            </h2>
            <h2
              class="p-popup_body_title"
              :class="
                props.classCustom == 'lp-ebisu-room'
                  ? 'ebisu-custom'
                  : props.classCustom == 'lp-forparty'
                  ? 'forparty-custom'
                  : ''
              "
              v-else-if="props.contactCateringLp"
            >
              飲食 問い合わせフォーム
            </h2>
            <h2
              class="p-popup_body_title"
              :class="
                props.classCustom == 'lp-ebisu-room' ? 'ebisu-custom' : ''
              "
              v-else-if="props.classCustom == 'lp-ebisu-room'"
            >
              {{ dataFormInquiry.name_space }} 問い合わせフォーム
            </h2>
            <h2
              class="p-popup_body_title"
              :class="
                props.classCustom == 'lp-forparty' ? 'forparty-custom' : ''
              "
              v-else-if="props.classCustom == 'lp-forparty'"
            >
              問い合わせフォーム
            </h2>
            <h2
              class="p-popup_body_title"
              :class="props.classCustom == 'use-scene' ? 'usescene-custom' : ''"
              v-else-if="props.classCustom == 'use-scene'"
            >
              問い合わせフォーム
            </h2>
            <div
              class="c-form"
              :class="
                props.classCustom == 'lp-ebisu-room'
                  ? 'ebisu-custom'
                  : props.classCustom == 'lp-forparty'
                  ? 'forparty-custom'
                  : props.classCustom == 'use-scene'
                  ? 'usescene-custom'
                  : ''
              "
            >
              <form @submit.prevent="submitForm">
                <!-- <Field type="hidden" name="is_lp"
                                            :value="props.classCustom" /> -->
                <Field
                  type="text"
                  name="form_type"
                  hidden
                  v-model="dataFormInquiry.form_type"
                />
                <div
                  class="c-form-detail"
                  :class="{ hidden: !isLpForPartyOrUseScene }"
                  v-if="!props.contactCateringLp"
                >
                  <h6>スペース名<span>必須</span></h6>
                  <div class="c-form-detail_group">
                    <Field
                      type="text"
                      placeholder="スペース名"
                      name="name_space"
                      v-model="dataFormInquiry.name_space"
                    />
                    <ErrorMessage
                      style="color: red; padding-top: 6px"
                      name="name_space"
                    />
                  </div>
                </div>
                <div class="p-popup_body_inqiry">
                  <h6>
                    お問い合わせ内容
                    <span v-if="!props.contactCateringLp">必須</span>
                  </h6>
                  <div
                    class="p-popup_body_inqiry_list"
                    v-if="!props.contactCateringLp"
                  >
                    <InputRadio
                      :optionProps="dataContentOfInquiry"
                      :modelValue="dataFormInquiry.content"
                      @update:modelValue="
                        (newValue) => (dataFormInquiry.content = newValue)
                      "
                    />
                    <span role="alert" style="color: red; padding-top: 6px;" v-if="isContentErrorMessage"> {{ isContentErrorMessage }}</span>
                  </div>
                  <p
                    v-else
                    class="text-[#222] text-[14px] font-normal leading-[20px] font-poppins ml-2.5"
                  >
                    {{ dataFormInquiry.name_space }} 飲食に関して
                  </p>
                </div>
                <!-- <div class="c-form-detail" :class="{ 'hidden': !props.classCustom }"> -->
                <!-- <h6>お問い合わせスペース <span>必須</span></h6>
                                    <div class="c-form-detail_group">
                                        <Field type="text" placeholder="スペース名" name="name_space"
                                            v-model="dataFormInquiry.name_space" />
                                        <ErrorMessage style="color: red; padding-top: 6px" name="name_space" />
                                    </div> -->
                <!-- </div> -->
                <div class="c-form-detail">
                  <h6>お名前 <span>必須</span></h6>
                  <div class="c-form-detail_group">
                    <div class="c-form-detail_group_item">
                      <Field
                        type="text"
                        placeholder="姓"
                        name="frist_name"
                        v-model="dataFormInquiry.frist_name"
                      />
                      <ErrorMessage
                        style="color: red; padding-top: 6px"
                        name="frist_name"
                      />
                    </div>
                    <div class="c-form-detail_group_item">
                      <Field
                        type="text"
                        placeholder="名"
                        name="last_name"
                        v-model="dataFormInquiry.last_name"
                      />
                      <ErrorMessage
                        style="color: red; padding-top: 6px"
                        name="last_name"
                      />
                    </div>
                  </div>
                </div>
                <div class="c-form-detail">
                  <h6>お名前（かな） <span>必須</span></h6>
                  <div class="c-form-detail_group">
                    <div class="c-form-detail_group_item">
                      <Field
                        type="text"
                        placeholder="せい"
                        name="frist_name_kana"
                        v-model="dataFormInquiry.frist_name_kana"
                      />
                      <ErrorMessage
                        style="color: red; padding-top: 6px"
                        name="frist_name_kana"
                      />
                    </div>
                    <div class="c-form-detail_group_item">
                      <Field
                        type="text"
                        placeholder="めい"
                        name="last_name_kana"
                        v-model="dataFormInquiry.last_name_kana"
                      />
                      <ErrorMessage
                        style="color: red; padding-top: 6px"
                        name="last_name_kana"
                      />
                    </div>
                  </div>
                </div>
                <div class="c-form-detail">
                  <h6>会社・団体名</h6>
                  <div class="c-form-detail_group">
                    <Field
                      type="text"
                      name="company_name"
                      v-model="dataFormInquiry.company_name"
                      placeholder="株式会社あどばる"
                    />
                  </div>
                </div>
                <div class="c-form-detail">
                  <h6>会社・団体名（かな）</h6>
                  <div class="c-form-detail_group">
                    <Field
                      type="text"
                      name="company_name_kana"
                      v-model="dataFormInquiry.company_name_kana"
                      placeholder="かぶしきがいしゃあどばる"
                    />
                    <ErrorMessage
                      style="color: red; padding-top: 6px"
                      name="company_name_kana"
                    />
                  </div>
                </div>
                <div class="c-form-detail">
                  <h6>電話番号（"-"なし・数字のみ）<span>必須</span></h6>
                  <div class="c-form-detail_group">
                    <Field
                      type="text"
                      placeholder="0368008931"
                      name="phone_number"
                      v-model="dataFormInquiry.phone_number"
                    />
                    <ErrorMessage
                      style="color: red; padding-top: 6px"
                      name="phone_number"
                    />
                  </div>
                </div>
                <div class="c-form-detail">
                  <h6>メールアドレス <span>必須</span></h6>
                  <div class="c-form-detail_group">
                    <Field
                      type="text"
                      placeholder="timesharing@adval.jp"
                      name="email"
                      v-model="dataFormInquiry.email"
                    />
                    <ErrorMessage
                      style="color: red; padding-top: 6px"
                      name="email"
                    />
                  </div>
                </div>
                <div class="p-popup_body_about">
                  <h6
                    class="p-popup_body_about_title"
                    @click="handleMore"
                    :class="{ more: isMore == true }"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="24"
                      viewBox="0 0 25 24"
                      fill="none"
                    >
                      <path
                        d="M12.5 8.29492L6.5 14.2949L7.91 15.7049L12.5 11.1249L17.09 15.7049L18.5 14.2949L12.5 8.29492Z"
                        fill="black"
                      />
                    </svg>
                    <span>メールの受信設定について</span>
                  </h6>
                  <p class="p-popup_body_about_content" v-if="isMore">
                    お問い合わせ送信後、ご入力いただいたメールアドレスに「<b>info@time-sharing.jp</b>」から受付完了メールが自動送信されます。受信設定をされている場合は「<b>info@time-sharing.jp</b>」からのメールが受信できるように設定してください。
                  </p>
                </div>
                <div class="c-form-detail" v-if="!props.contactCateringLp">
                  <h6>利用希望日時／内見希望日時</h6>
                  <div class="c-form-detail_group">
                    <Field
                      as="textarea"
                      name="date_schedule_and_schedule_rate"
                      id=""
                      rows="4.5"
                      v-model="dataFormInquiry.date_schedule_and_schedule_rate"
                      placeholder="2023年4月1日（土）～4月7日（金）9:00-18:00"
                    />
                  </div>
                  <p class="c-form-detail_des">
                    ※見学を希望される場合はご希望日を3候補ほどいただけるとスムーズにご案内可能です。
                  </p>
                </div>
                <div class="c-form-detail">
                  <h6>備考</h6>
                  <div class="c-form-detail_group">
                    <Field
                      as="textarea"
                      name="comment"
                      id=""
                      rows="4.5"
                      placeholder="予算○円程度でケータリングを検討しています。 "
                      v-model="dataFormInquiry.comment"
                    />
                  </div>
                  <p class="c-form-detail_des">
                    備品やケータリング等に関するご質問、ご相談がございましたらご入力ください。
                  </p>
                </div>
                <div class="p-popup_body_age-confirm">
                  <h6>年齢確認（お申込み者様） <span>必須</span></h6>
                  <div class="p-popup_body_age-confirm_list">
                    <InputRadio
                      :optionProps="optionConfirmAge"
                      :modelValue="dataFormInquiry.confirm_age"
                      @update:modelValue="
                        (newValue) => (dataFormInquiry.confirm_age = newValue)
                      "
                    />
                    <p>※20歳未満の方は22時以降ご利用いただけません。</p>
                  </div>
                </div>
                <div class="p-popup_body_age-confirm">
                  <!-- <h6>規約の取り扱い <span>必須</span></h6> -->
                  <div class="p-popup_body_term-condition_checkbox">
                    <label for="">
                      <Field
                        type="checkbox"
                        name="member_agreement"
                        :value="true"
                        :unchecked-value="false"
                        id=""
                        v-model="dataFormInquiry.member_agreement"
                      />
                      <span class="term-checkbox_custom"></span>
                      <p>
                        <a href="/customer/member-agreement" target="_blank"
                          >利用規約</a
                        >に同意する
                      </p>
                    </label>
                    <ErrorMessage
                      style="color: red; padding-top: 6px"
                      name="member_agreement"
                    />
                    <!-- <p class="p-popup_body_term-condition_des">※規約の取扱いをご確認ください。<br>
                                            本サイトのユーザーはこの内容を理解し、同意したものと見なします。</p> -->
                  </div>
                </div>
                <div class="p-popup_body_age-confirm">
                  <!-- <h6>個人情報の取り扱い <span>必須</span></h6> -->
                  <div class="p-popup_body_person-info_checkbox">
                    <label for="">
                      <Field
                        type="checkbox"
                        name="accept_deal"
                        id=""
                        :value="true"
                        :unchecked-value="false"
                        v-model="dataFormInquiry.accept_deal"
                      />
                      <span class="term-checkbox_custom"></span>
                      <p>
                        <a href="/purpose" target="_blank"
                          >個人情報の取扱い</a
                        >に同意する
                      </p>
                    </label>
                    <ErrorMessage
                      style="color: red; padding-top: 6px"
                      name="accept_deal"
                    />
                    <p class="p-popup_body_person-info_des">
                      ※本サイトのユーザーはこの内容を理解し、同意したものと見なします。
                    </p>
                  </div>
                </div>
                <div class="p-popup_body_list-button-wrap">
                  <div id="message-send-form">
                    <p v-if="Object.keys(errors).length > 0" class="error_msg">
                      入力内容に問題があります。確認して再度お試しください。
                    </p>
                    <p v-if="complete" class="complete_msg">
                      ありがとうございます、メッセージを送信しました。
                    </p>
                  </div>
                  <div class="p-popup_body_list-button">
                    <a
                      class="p-popup_body_list-button_close"
                      @click="handleClose"
                      >とじる</a
                    >
                    <button
                      :class="
                        !isBtnSend
                          ? 'p-popup_body_list-button_send'
                          : 'p-popup_body_list-button_close'
                      "
                    >
                      <i
                        class="fa fa-circle-o-notch fa-spin"
                        style="margin-top: 2px; margin-right: 9px"
                        v-if="isBtnSend"
                      ></i>
                      送信
                    </button>
                  </div>
                </div>
                <div class="p-popup_body_text-bot">
                  ※お客様宛に自動メールが送信されますので、内容をご確認ください。<br />
                  ※2営業日以内に返信が確認できない場合は再度お問い合わせください。
                </div>
                <!-- <div id="message-send-form">
                                <p v-if="Object.keys(errors).length > 0" class="error_msg">
                                    入力内容に問題があります。確認して再度お試しください。
                                </p>
                                <p v-if="complete" class="complete_msg">
                                    ありがとうございます、メッセージを送信しました。
                                </p>
                               </div> -->
              </form>
            </div>
          </div>
        </div>
      </div>
    </v-card>
  </div>
</template>

<script setup>
/* eslint-disable */
import "./FormDetail.scss";

import {
  defineEmits,
  ref,
  defineProps,
  computed,
  onMounted,
  inject,
  watch
} from "vue";
import InputRadio from "@/client/components/InputRadio";
import { dataContentOfInquiry, optionConfirmAge } from "@/client/const/options";
import { useI18n } from "vue-i18n";
import * as Yup from "yup";
import { ErrorMessage, Field, useForm } from "vee-validate";
import useCustomer from "@/client/store/Customer";

import { sendContactSpaceApi } from "@/client/api";

const store = useCustomer();
const toast = inject("$toast");

const { t } = useI18n();

const emit = defineEmits(["handleCloseModalList"]);

const props = defineProps({
  showTitle: {
    type: Boolean,
    default: false, // default to false if not passed
  },
  showTitleTourFlag: {
    type: Boolean,
    default: false, // default to false if not passed
  },
  nameSpace: {
    type: String,
    required: true,
  },
  idSpace: {
    type: Number,
    required: true,
  },
  webTourStatus: {
    type: Number,
    required: true,
  },
  classCustom: {
    type: String,
  },
  contactCateringLp: {
    type: Boolean,
    default: false,
  },
  pageName: {
    type: String,
    default: () => "",
  },
});

const isLpForPartyOrUseScene = computed(() => {
  return (
    props.classCustom === "lp-forparty" || props.classCustom === "use-scene"
  );
});

const handleClose = () => {
  emit("handleCloseModalList", false);
};

const complete = ref(false);
const isMore = ref(false);
const isBtnSend = ref(false);
const isContentErrorMessage = ref("");
const isNameSpaceVisible = ref(
  props.classCustom === "lp-forparty" && props.contactCateringLp == false
);

const dataFormInquiry = ref({
  form_type:
    (props.classCustom === "lp-forparty" && !props.contactCateringLp)
      ? "space-forparty"
      : (props.classCustom === "use-scene" && !props.contactCateringLp)
      ? "space-forparty-detail"
      : "space-booking",
  content: "",
  name_space: props.nameSpace,
  real_name: props.nameSpace,
  last_name: "",
  frist_name: "",
  last_name_kana: "",
  frist_name_kana: "",
  company_name: "",
  company_name_kana: "",
  phone_number: "",
  email: "",
  comment: "",
  date_schedule_and_schedule_rate: "",
  confirm_age: "20歳以上",
  department_name: "",
  date_for_viewing: "希望しない",
  date_for_viewing_note: "",
  schedule_rate: "",
  date_schedule: "",
  food_and_drink: "なし",
  food_and_drink_note: "",
  coupon_number: "",
  mumber_of_users: "",
  member_agreement: false,
  accept_deal: false,
  is_contact: false,
  page_name: props?.pageName ? props?.pageName : '',
});

const hiraganaRegex = /^[ぁ-ん_　\-ー ]+$/;
const { validate, errors } = useForm({
  initialValues: {},
  validationSchema: Yup.object({
    name_space: Yup.string().when([], {
      is: () => isNameSpaceVisible.value,
      then: Yup.string().required(t(`detail_Price.form_detail.error_require`)),
      otherwise: Yup.string().nullable(),
    }),
    last_name: Yup.string()
      .typeError(t(`detail_Price.form_detail.error_require`))
      .trim()
      .required(t(`detail_Price.form_detail.error_require`)),
    frist_name: Yup.string()
      .typeError(t(`detail_Price.form_detail.error_require`))
      .trim()
      .required(t(`detail_Price.form_detail.error_require`)),
    last_name_kana: Yup.string()
      .required(t(`detail_Price.form_detail.error_require`))
      .matches(hiraganaRegex, {
        message: "ひらがなで入力してください。",
        excludeEmptyString: true,
      }),
    frist_name_kana: Yup.string()
      .required(t(`detail_Price.form_detail.error_require`))
      .matches(hiraganaRegex, {
        message: "ひらがなで入力してください。",
        excludeEmptyString: true,
      }),
    company_name_kana: Yup.string()
      .nullable()
      .matches(hiraganaRegex, {
        message: t(`detail_Price.form_detail.error_hiragana`),
        excludeEmptyString: true,
      }),
    phone_number: Yup.string()
      .required(t(`detail_Price.form_detail.error_require`))
      .matches(
        "^[0-9]+$",
        t(`detail_Price.form_detail.error_require_phone_format`)
      )
      .min(10, t(`detail_Price.form_detail.error_require`))
      .max(12, t(`detail_Price.form_detail.error_phone_max`)),
    email: Yup.string()
      .required(t(`detail_Price.form_detail.error_require`))
      .email(t(`detail_Price.form_detail.error_require_email`).trim()),
    member_agreement: Yup.boolean().oneOf(
      [true],
      t(`規約を確認してチェックをつけてください`)
    ),
    accept_deal: Yup.boolean().oneOf(
      [true],
      t(`個人情報の取り扱いを確認してチェックをつけてください`)
    ),
    // content: Yup.string().required("お問い合わせ内容を選択してください"),
  }),
});

watch(() => dataFormInquiry.value.content, (newValue) => {
  if(newValue){
    isContentErrorMessage.value = "";
  }
});

const submitForm = async () => {
  await validate();
  if (!dataFormInquiry.value.content) {
    console.log('helllo' , dataFormInquiry.value.content)
    isContentErrorMessage.value = "お問い合わせ内容を選択してください";
    return;
  }
  if(Object.keys(errors.value).length > 0){
    return;
  }
  store.isLoading = true;
  isBtnSend.value = true;
  try {
    setTimeout(async () => {
      isBtnSend.value = false;
      await sendContact().then((res) => {
        complete.value = true;
      });
    }, 2000);
  } catch (error) {
    console.log(error.message);
  } finally {
    setTimeout(() => {
      isBtnSend.value = false;
      store.isLoading = false;
    }, 1000);
  }
};

const sendContact = async () => {
  store.isLoading = true;
  try {
    let formData = new FormData();
    if (props.contactCateringLp) {
      dataFormInquiry.value.content = "飲食に関して";
    }
    formData.append("dataProfile", JSON.stringify(dataFormInquiry.value));
    formData.append("space_id", props.idSpace);
    const response = await sendContactSpaceApi(formData);
    return response;
  } catch (error) {
    console.log(error);
    toast.error(error.message);
  } finally {
    store.isLoading = false;
    // toast.success('フォームを正常に送信しました');
    handleScrollMessageSendForm();
  }
};

const handleScrollMessageSendForm = () => {
  document.getElementById("message-send-form").classList.add("min-h-[30px]");
  setTimeout(() => {
    document
      .getElementById("message-send-form")
      .scrollIntoView({ behavior: "smooth" });
  }, 50);
};

const handleMore = () => {
  isMore.value == true ? (isMore.value = false) : (isMore.value = true);
};

const isPreview = computed(() => {
  let boolean = true;
  props.webTourStatus == 0 ? (boolean = true) : (boolean = false);
  return boolean;
});

const checkDisplayCheckbox = () => {
  if (isPreview.value) {
    const listCheckBox = document.getElementsByClassName("input_radio_label");
    const checkHiden = listCheckBox[2].innerText;
    if (checkHiden == "内見希望") {
      listCheckBox[2].classList.add("d-none");
    }
  } 
  // else {
  //   const listCheckBox = document.getElementsByName("content");
  //   if(listCheckBox[2]) {
  //       listCheckBox[2].checked = true;
  //   }
  // }
};
onMounted(() => {
  checkDisplayCheckbox();
});
</script>

<style scoped lang="scss"></style>
